// @flow
import type { DumbObject } from "./types";

export default function error(e: DumbObject): void {
  console.error("An unexpected error occurred:", e);

  // TODO: add remote reporter tool.
  throw e;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/errorReporter.js